import { Button } from "@faire/web--source/slate/Button";
import { Column } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import brandPortalMyShopSettings from "@faire/web-api--source/routes/brand-portal/my-shop/settings";
import React, { type JSX } from "react";

import { Bold } from "../common/Bold";

export const InternationalOrderSettings: React.FC = () => {
  return (
    <Column>
      <Typography>
        <StrictLocalMsg
          defaultMessage="On Faire, you can choose where to sell your products. You can limit selling in certain regions if you already have sales representatives or distributors there, or if your products don’t meet consumer protection laws in those areas. You can also turn on sales in new regions when you’re ready for customers in those areas."
          description={{
            text: "Title for the instant answer about updating international order settings",
          }}
        />
      </Typography>
      <Spacer height="1x" />
      <Typography>
        <StrictLocalMsg
          defaultMessage="Changes to these settings can be made at any time in the <BoldFormatting>Marketplace</BoldFormatting> tab in your portal under <LinkFormatting>Shop settings</LinkFormatting>. Here you can select which countries you’ll sell to, as well as setting location specific order minimums."
          values={{
            BoldFormatting: (chunks: JSX.Element) => BoldFormatting(chunks),
            LinkFormatting: (chunks: JSX.Element) =>
              shopSettingLinkFormatting(chunks),
          }}
          description={{
            text: "Description for the instant answer about updating international order settings",
          }}
        />
      </Typography>
    </Column>
  );
};

const shopSettingLinkFormatting = (chunks: JSX.Element) => (
  <Button
    variant="tertiary"
    linkTo={brandPortalMyShopSettings()}
    target="_blank"
  >
    <Bold>{chunks}</Bold>
  </Button>
);

const BoldFormatting = (chunks: JSX.Element) => <Bold>{chunks}</Bold>;
